import React from 'react';
import '../../styles/common.css';
import styles from './GettingStarted.module.css';

const GettingStarted = () => {
  const steps = [
    {
      number: 1,
      title: 'Купите Hytale',
      description: 'Приобретите лицензию на игру на официальном сайте Hypixel Studios. Игра доступна на PC, Mac и других платформах.',
      details: 'Перейдите на официальный сайт Hytale и следуйте инструкциям по покупке. После успешной покупки вам будет предоставлен доступ к клиенту игры.'
    },
    {
      number: 2,
      title: 'Запустите игру',
      description: 'Установите и откройте Hytale, дождитесь полной загрузки. Это может занять некоторое время при первом запуске.',
      details: 'После установки откройте Hytale на вашем компьютере. Убедитесь, что ваша интернет-соединение стабильно и скачивание файлов игры завершено полностью.'
    },
    {
      number: 3,
      title: 'Откройте серверы',
      description: 'В главном меню Hytale нажмите кнопку "Servers" (Серверы). Это откроет список доступных серверов для подключения.',
      details: 'Кнопка "Servers" обычно находится в главном меню рядом с кнопкой "Singleplayer" (Одиночная игра). Нажмите на неё, чтобы увидеть список всех доступных серверов.'
    },
    {
      number: 4,
      title: 'Добавьте InterWorld',
      description: 'Нажмите "Add Server" (Добавить сервер) и введите адрес play.interworld.fun, затем нажмите "Connect".',
      details: 'В списке серверов найдите кнопку "Add Server" или "+" и нажмите её. В появившемся поле введите точный адрес: play.interworld.fun. Убедитесь в правильности адреса и нажмите "Connect" для подключения.'
    },
    {
      number: 5,
      title: 'Начните играть',
      description: 'Выберите сервер InterWorld из списка и присоединитесь к игре. Добро пожаловать в наше сообщество!',
      details: 'После успешного добавления сервера вы увидите InterWorld в списке доступных серверов. Нажмите на него и выберите персонажа или создайте нового. После этого вы сразу же присоединитесь к игре!'
    }
  ];

  return (
    <main className={`container ${styles.gettingStarted}`}>
      <div className="container">
        <div style={{marginTop: '1rem'}}>
          <header className={styles.header}>
            <h1 className="title">Как начать играть на InterWorld</h1>
            <p className="lead">Простая инструкция из 5 шагов для подключения к серверу</p>
          </header>

          <div className={styles.stepsContainer}>
            {steps.map((step) => (
              <div key={step.number} className={`glassCard ${styles.step}`}>
                <div className={styles.stepNumber}>{step.number}</div>
                <div className={styles.stepContent}>
                  <h2 className={styles.stepTitle}>{step.title}</h2>
                  <p className={styles.stepDescription}>{step.description}</p>
                  <p className={styles.stepDetails}>{step.details}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={`glassCard ${styles.supportBlock}`}>
            <h2 className="title">Возникли проблемы?</h2>
            <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              Если у вас возникли вопросы или проблемы при подключении — не стесняйтесь обращаться к нам. Наша активная команда поддержки всегда готова помочь.
            </p>
            <a href="/contacts" className="btnPrimaryCustom">
              Свяжитесь с нами
            </a>
          </div>

          <div className={`glassCard ${styles.supportBlock}`}>
            <h2 className="title">Поддержите проект</h2>
            <p style={{fontSize: '16px', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              InterWorld создаётся игроками для игроков. Нам важна ваша помощь: финансовая поддержка и волонтёрский вклад (тестирование, моддинг, проведение ивентов).
            </p>
            <a href="/contacts" className="btnPrimaryCustom">
              Помочь проекту
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default GettingStarted;
